exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".trygg-e-handel {\n  padding: 60px;\n  max-width: 768px;\n  margin: auto; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./src/components/TryggEHandel/TryggEHandel.scss
// module id = 1756
// module chunks = 0